import { render, staticRenderFns } from "./SplitCalendar.vue?vue&type=template&id=b7ed8824&"
import script from "./SplitCalendar.vue?vue&type=script&lang=js&"
export * from "./SplitCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports